/* eslint-disable @typescript-eslint/no-explicit-any */
import { Typography } from 'omakase';
import { customDimensions } from 'utils/Analytics';
import Anchor from 'components/Anchor';
import BaseComponent from '@tock/shared/components/BaseComponent';

interface Props {
  href: string;
}

export function getExternalOpenTableUrl(
  externalReservationsUrl: any,
  size: string | number,
  date: any,
  time: any
) {
  if (!externalReservationsUrl) {
    return '';
  }
  // When we put links into the DB they must end in a query string.
  // Thankfully, if we forget OT will handle it correctly but we shouldn't rely on that
  return encodeURI(`${externalReservationsUrl}&p=${size}&sd=${date}+${time}`);
}

export default class OpenTableExternalLink extends BaseComponent<Props> {
  componentDidMount() {
    if (BROWSER) {
      requestIdleCallback(() => {
        // tslint:disable:strict-type-predicates
        (window as any).analytics.setDimensionInTockOnly(
          customDimensions.HAS_EXTERNAL_LINK,
          'true'
        );
      });
    }
  }

  render() {
    if (!this.props.href) {
      return null;
    }

    return (
      <div className="OpenTableExternalLink">
        <div className="OpenTableExternalLink-linkContainer">
          <div className="OpenTableExternalLink-linkDescription">
            <Typography color="inherit" component="span" variant="heading03">
              Looking for a la carte reservations?
            </Typography>
          </div>
          <Anchor
            className="OpenTableExternalLink-link Button Button--secondary"
            href={this.props.href}
            target="_blank"
            trackingCategory="externalOTReservationLink"
          >
            <Typography color="inherit" component="span" variant="body02">
              Visit OpenTable
            </Typography>
          </Anchor>
        </div>
      </div>
    );
  }
}
